/* ==========================================================================
   Nookto · Product Showcase — interactions
   - <sx-carousel>  : centre-mode, infinite carousel with clones + drag + dots
   - reveal on scroll, sticky purchase bar, lightbox, immersive header
   No dependencies. Safe to execute more than once (theme editor re-renders).
   ========================================================================== */
(function () {
  if (window.__SX_BOOTED__) {
    // re-run the cheap initialisers after a theme-editor section reload
    if (window.__SX_REINIT__) window.__SX_REINIT__();
    return;
  }
  window.__SX_BOOTED__ = true;

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function fullSrc(el, img) {
    var explicit = el.getAttribute("data-sx-full");
    if (explicit) return explicit;
    if (!img) return "";
    var srcset = img.getAttribute("srcset");
    if (srcset) {
      var candidates = srcset.split(",").map(function (s) { return s.trim().split(/\s+/)[0]; }).filter(Boolean);
      if (candidates.length) return candidates[candidates.length - 1];
    }
    return img.currentSrc || img.src || "";
  }


  /* ----------------------------------------------------------------------
     Lightbox (one <dialog> shared by every showcase carousel)
     ---------------------------------------------------------------------- */
  var Lightbox = (function () {
    var dialog = null;
    var imgEl = null;
    var countEl = null;
    var items = [];
    var index = 0;

    function build() {
      if (dialog) return;
      dialog = document.createElement("dialog");
      dialog.className = "sx-lightbox";
      dialog.setAttribute("aria-label", "Image viewer");
      dialog.innerHTML =
        '<button type="button" class="sx-lightbox__close" aria-label="Close">&times;</button>' +
        '<button type="button" class="sx-lightbox__nav sx-lightbox__nav--prev" aria-label="Previous image">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 4 7 12l8 8"/></svg></button>' +
        '<img class="sx-lightbox__img" alt="">' +
        '<button type="button" class="sx-lightbox__nav sx-lightbox__nav--next" aria-label="Next image">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="m9 4 8 8-8 8"/></svg></button>' +
        '<div class="sx-lightbox__count"></div>';
      document.body.appendChild(dialog);
      imgEl = dialog.querySelector(".sx-lightbox__img");
      countEl = dialog.querySelector(".sx-lightbox__count");

      dialog.querySelector(".sx-lightbox__close").addEventListener("click", close);
      dialog.querySelector(".sx-lightbox__nav--prev").addEventListener("click", function () { step(-1); });
      dialog.querySelector(".sx-lightbox__nav--next").addEventListener("click", function () { step(1); });
      dialog.addEventListener("click", function (e) {
        if (e.target === dialog) close();
      });
      dialog.addEventListener("keydown", function (e) {
        if (e.key === "ArrowLeft") { e.preventDefault(); step(-1); }
        if (e.key === "ArrowRight") { e.preventDefault(); step(1); }
      });
      dialog.addEventListener("close", function () {
        document.documentElement.classList.remove("sx-lightbox-open");
      });
      // swipe
      var sx = null;
      dialog.addEventListener("pointerdown", function (e) { sx = e.clientX; });
      dialog.addEventListener("pointerup", function (e) {
        if (sx === null) return;
        var dx = e.clientX - sx;
        sx = null;
        if (Math.abs(dx) > 50) step(dx > 0 ? -1 : 1);
      });
    }

    function render() {
      var item = items[index];
      if (!item) return;
      imgEl.src = item.src;
      imgEl.alt = item.alt || "";
      countEl.textContent = items.length > 1 ? index + 1 + " / " + items.length : "";
      var multi = items.length > 1;
      dialog.querySelector(".sx-lightbox__nav--prev").style.display = multi ? "" : "none";
      dialog.querySelector(".sx-lightbox__nav--next").style.display = multi ? "" : "none";
    }

    function step(dir) {
      if (!items.length) return;
      index = (index + dir + items.length) % items.length;
      render();
    }

    function open(list, start) {
      build();
      items = list;
      index = start || 0;
      render();
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add("sx-lightbox-open");
    }

    function close() {
      if (!dialog) return;
      dialog.close();
      document.documentElement.classList.remove("sx-lightbox-open");
    }

    return { open: open, close: close };
  })();

  /* ----------------------------------------------------------------------
     Carousel
     ---------------------------------------------------------------------- */
  var SxCarousel = (function () {
    function Carousel(root) {
      this.root = root;
      this.viewport = root.querySelector("[data-sx-viewport]");
      this.track = root.querySelector("[data-sx-track]");
      if (!this.viewport || !this.track) return;

      this.realSlides = Array.prototype.slice.call(this.track.querySelectorAll("[data-sx-slide]"));
      if (!this.realSlides.length) return;

      this.loop = root.getAttribute("data-loop") !== "false";
      this.center = root.getAttribute("data-center") !== "false";
      this.autoplay = parseFloat(root.getAttribute("data-autoplay") || "0") * 1000;
      this.arrowPrev = root.querySelector("[data-sx-prev]");
      this.arrowNext = root.querySelector("[data-sx-next]");
      this.dotsWrap = root.querySelector("[data-sx-dots]");
      this.count = this.realSlides.length;
      this.cloneCount = this.loop ? Math.min(3, this.count) : 0;
      this.index = this.cloneCount;
      this.timer = null;
      this.dragging = false;
      this.pointerId = null;
      this.startX = 0;
      this.startY = 0;
      this.dragDelta = 0;
      this.locked = false;

      this.buildClones();
      this.buildDots();
      this.bind();
      this.measure();
      this.jumpTo(this.index, true);
      this.updateUi();

      if (this.autoplay) this.startAuto();
    }

    Carousel.prototype.buildClones = function () {
      if (!this.cloneCount) return;
      var i, node;
      for (i = this.count - this.cloneCount; i < this.count; i++) {
        node = this.realSlides[i].cloneNode(true);
        node.setAttribute("aria-hidden", "true");
        node.setAttribute("data-sx-clone", "true");
        node.querySelectorAll("a, button").forEach(function (el) {
          el.tabIndex = -1;
          el.setAttribute("aria-hidden", "true");
        });
        this.track.insertBefore(node, this.track.firstChild);
      }
      for (i = 0; i < this.cloneCount; i++) {
        node = this.realSlides[i].cloneNode(true);
        node.setAttribute("aria-hidden", "true");
        node.setAttribute("data-sx-clone", "true");
        node.querySelectorAll("a, button").forEach(function (el) {
          el.tabIndex = -1;
          el.setAttribute("aria-hidden", "true");
        });
        this.track.appendChild(node);
      }
      this.allSlides = Array.prototype.slice.call(this.track.querySelectorAll("[data-sx-slide]"));
    };

    Carousel.prototype.buildDots = function () {
      if (!this.dotsWrap) return;
      this.dotsWrap.innerHTML = "";
      this.dots = [];
      for (var i = 0; i < this.count; i++) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "sx-dot";
        b.setAttribute("aria-label", "Go to image " + (i + 1));
        b.setAttribute("data-index", String(i));
        this.dotsWrap.appendChild(b);
        this.dots.push(b);
      }
    };

    Carousel.prototype.measure = function () {
      var slide = this.allSlides[this.index] || this.allSlides[0];
      if (!slide) return;
      this.slideWidth = slide.getBoundingClientRect().width;
      var styles = window.getComputedStyle(this.track);
      var gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
      this.gap = gap;
      this.viewportWidth = this.viewport.getBoundingClientRect().width;
      if (this.arrowPrev) {
        this.root.style.setProperty("--sx-slide-half", this.slideWidth / 2 + "px");
      }
    };

    Carousel.prototype.offsetFor = function (index) {
      var step = this.slideWidth + this.gap;
      var base = this.center ? (this.viewportWidth - this.slideWidth) / 2 : 0;
      return base - index * step;
    };

    Carousel.prototype.jumpTo = function (index, instant) {
      this.measure();
      this.index = index;
      if (instant) this.track.classList.add("is-static");
      this.track.style.transform = "translate3d(" + this.offsetFor(index) + "px,0,0)";
      if (instant) {
        // force reflow so the class removal does not animate
        void this.track.offsetWidth;
        this.track.classList.remove("is-static");
      }
      this.updateUi();
    };

    // Transform actually painted right now — mid-glide this is *not* offsetFor(index).
    Carousel.prototype.currentOffset = function () {
      var value = window.getComputedStyle(this.track).transform;
      if (value && value !== "none" && window.DOMMatrixReadOnly) {
        try { return new DOMMatrixReadOnly(value).m41; } catch (e) {}
      }
      return this.offsetFor(this.index);
    };

    Carousel.prototype.duration = function () {
      var raw = window.getComputedStyle(this.track).transitionDuration || "0s";
      var first = raw.split(",")[0].trim();
      var value = parseFloat(first) || 0;
      return /ms$/.test(first) ? value : value * 1000;
    };

    Carousel.prototype.stopNormalise = function () {
      if (this.snapTimer) clearTimeout(this.snapTimer);
      this.snapTimer = null;
    };

    // transitionend is the happy path; the timer covers interrupted or
    // suppressed transitions (background tab, display:none, old browsers).
    Carousel.prototype.scheduleNormalise = function () {
      var self = this;
      this.stopNormalise();
      if (!this.loop || !this.cloneCount) return;
      this.snapTimer = setTimeout(function () { self.normalise(); }, this.duration() + 120);
    };

    Carousel.prototype.goTo = function (index) {
      if (this.locked) return;
      this.measure();

      if (this.loop && this.cloneCount) {
        var total = this.allSlides.length;
        var cycles = 0;
        while (index < 0) { index += this.count; cycles -= 1; }
        while (index >= total) { index -= this.count; cycles += 1; }
        if (cycles) {
          // Ran out of clones (fast repeated clicks). Re-base one whole cycle
          // back without moving a pixel: the painted offset and the target
          // shift by exactly count * step, so the glide just continues.
          var offset = this.currentOffset() - cycles * this.count * (this.slideWidth + this.gap);
          this.index = index;
          this.track.classList.add("is-static");
          this.track.style.transform = "translate3d(" + offset + "px,0,0)";
          void this.track.offsetWidth;
          this.track.classList.remove("is-static");
        }
      }

      if (reduceMotion) {
        this.jumpTo(index, true);
        this.normalise();
        return;
      }

      this.index = index;
      this.track.style.transform = "translate3d(" + this.offsetFor(index) + "px,0,0)";
      this.updateUi();
      this.scheduleNormalise();
    };

    Carousel.prototype.logical = function () {
      if (!this.cloneCount) return this.index;
      return (this.index - this.cloneCount + this.count * 10) % this.count;
    };

    Carousel.prototype.updateUi = function () {
      var logical = this.logical();
      if (this.dots) {
        for (var i = 0; i < this.dots.length; i++) {
          this.dots[i].classList.toggle("is-active", i === logical);
          this.dots[i].setAttribute("aria-current", i === logical ? "true" : "false");
        }
      }
      if (!this.loop) {
        if (this.arrowPrev) this.arrowPrev.disabled = this.index <= 0;
        if (this.arrowNext) this.arrowNext.disabled = this.index >= this.count - 1;
      }
    };

    Carousel.prototype.next = function () {
      if (!this.loop && this.index >= this.count - 1) return;
      this.goTo(this.index + 1);
    };
    Carousel.prototype.prev = function () {
      if (!this.loop && this.index <= 0) return;
      this.goTo(this.index - 1);
    };

    Carousel.prototype.normalise = function () {
      if (!this.cloneCount) return;
      this.stopNormalise();
      if (this.dragging) return;
      var logical = this.logical();
      if (this.index < this.cloneCount || this.index >= this.count + this.cloneCount) {
        this.locked = true;
        this.jumpTo(this.cloneCount + logical, true);
        // allow the browser a frame before accepting new moves
        var self = this;
        requestAnimationFrame(function () { self.locked = false; });
      }
    };

    Carousel.prototype.startAuto = function () {
      var self = this;
      this.stopAuto();
      this.timer = setInterval(function () {
        if (document.hidden || self.root.matches(":hover")) return;
        self.next();
      }, this.autoplay);
    };
    Carousel.prototype.stopAuto = function () {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    };

    Carousel.prototype.bind = function () {
      var self = this;
      if (this.arrowPrev) this.arrowPrev.addEventListener("click", function () { self.prev(); self.restartAuto(); });
      if (this.arrowNext) this.arrowNext.addEventListener("click", function () { self.next(); self.restartAuto(); });
      if (this.dotsWrap) {
        this.dotsWrap.addEventListener("click", function (e) {
          var dot = e.target.closest(".sx-dot");
          if (!dot) return;
          var i = parseInt(dot.getAttribute("data-index"), 10);
          // from a clone, hop to the identical real slide first (invisible)
          // so the glide to the chosen dot is never longer than one cycle
          if (self.loop && self.cloneCount) {
            var anchor = self.cloneCount + self.logical();
            if (anchor !== self.index) self.jumpTo(anchor, true);
          }
          self.goTo(self.cloneCount + i);
          self.restartAuto();
        });
      }

      this.track.addEventListener("transitionend", function (e) {
        if (e.target !== self.track || e.propertyName !== "transform") return;
        self.normalise();
      });

      // drag / swipe
      this.track.addEventListener("pointerdown", function (e) {
        if (e.pointerType === "mouse" && e.button !== 0) return;
        self.dragging = true;
        self.pointerId = e.pointerId;
        self.startX = e.clientX;
        self.startY = e.clientY;
        self.dragDelta = 0;
        self.stopNormalise();
        // grab the glide where it is painted, otherwise disabling the
        // transition would teleport it to the pending snap target
        self.baseTransform = self.currentOffset();
        self.track.style.transform = "translate3d(" + self.baseTransform + "px,0,0)";
        void self.track.offsetWidth;
        self.track.classList.add("is-dragging");
        self.stopAuto();
      });
      this.track.addEventListener("pointermove", function (e) {
        if (!self.dragging || e.pointerId !== self.pointerId) return;
        var dx = e.clientX - self.startX;
        var dy = e.clientY - self.startY;
        if (Math.abs(dx) < Math.abs(dy) && Math.abs(dy) > 12) {
          // vertical intent: hand the gesture back to the page, glide home
          self.dragging = false;
          self.track.classList.remove("is-dragging");
          void self.track.offsetWidth;
          self.goTo(self.index);
          return;
        }
        self.dragDelta = dx;
        self.track.style.transform = "translate3d(" + (self.baseTransform + dx) + "px,0,0)";
      });
      var release = function (e) {
        if (!self.dragging || (e.pointerId != null && e.pointerId !== self.pointerId)) return;
        self.dragging = false;
        self.track.classList.remove("is-dragging");
        // commit the released position before re-enabling the transition,
        // so the snap animates from the finger instead of jumping
        void self.track.offsetWidth;
        var dx = self.dragDelta || 0;
        self.dragDelta = 0;
        var threshold = Math.max(40, self.slideWidth * 0.16);
        if (dx < -threshold) self.next();
        else if (dx > threshold) self.prev();
        else self.goTo(self.index);
        self.restartAuto();
        if (Math.abs(dx) > 8) {
          self.suppressClick = true;
          setTimeout(function () { self.suppressClick = false; }, 50);
        }
      };
      var cancel = function () {
        if (!self.dragging) return;
        self.dragging = false;
        self.dragDelta = 0;
        self.track.classList.remove("is-dragging");
        void self.track.offsetWidth;
        self.goTo(self.index);
        self.restartAuto();
      };
      this.track.addEventListener("pointerup", release);
      this.track.addEventListener("pointercancel", cancel);
      this.track.addEventListener("pointerleave", release);

      this.track.addEventListener("click", function (e) {
        if (self.suppressClick) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      this.root.addEventListener("keydown", function (e) {
        if (e.key === "ArrowLeft") { e.preventDefault(); self.prev(); }
        if (e.key === "ArrowRight") { e.preventDefault(); self.next(); }
      });

      if (this.autoplay) {
        this.root.addEventListener("mouseenter", function () { self.stopAuto(); });
        this.root.addEventListener("mouseleave", function () { self.startAuto(); });
        this.root.addEventListener("focusin", function () { self.stopAuto(); });
        this.root.addEventListener("focusout", function () { self.startAuto(); });
      }

      if ("ResizeObserver" in window) {
        var ro = new ResizeObserver(function () {
          self.jumpTo(self.index, true);
        });
        ro.observe(this.viewport);
      } else {
        window.addEventListener("resize", function () { self.jumpTo(self.index, true); });
      }

      // lightbox trigger
      this.track.addEventListener("click", function (e) {
        var trigger = e.target.closest("[data-sx-zoom]");
        if (!trigger) return;
        if (self.suppressClick) return;
        e.preventDefault();
        var group = trigger.getAttribute("data-sx-group") || "default";
        var groupEls = Array.prototype.slice
          .call(self.root.querySelectorAll("[data-sx-zoom]"))
          .filter(function (el) { return (el.getAttribute("data-sx-group") || "default") === group; })
          .filter(function (el) { return !el.closest("[data-sx-clone]"); });
        var start = Math.max(0, groupEls.indexOf(trigger));
        var items = groupEls.map(function (el) {
          var img = el.querySelector("img");
          return { src: fullSrc(el, img), alt: img ? img.alt : "" };
        });
        var kept = items.filter(function (it) { return !!it.src; });
        if (kept.length !== items.length) start = 0;
        Lightbox.open(kept, Math.min(start, Math.max(0, kept.length - 1)));
      });
    };

    Carousel.prototype.restartAuto = function () {
      if (this.autoplay) this.startAuto();
    };

    return Carousel;
  })();

  /* ----------------------------------------------------------------------
     Page-level initialisers
     ---------------------------------------------------------------------- */
  var revealObserver = null;

  function initReveals(scope) {
    var els = (scope || document).querySelectorAll(".sx-reveal:not(.is-in)");
    if (!els.length) return;
    if (reduceMotion || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-in");
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { rootMargin: "0px 0px -12% 0px", threshold: 0.01 }
      );
    }
    els.forEach(function (el) { revealObserver.observe(el); });
  }

  function initCarousels(scope) {
    (scope || document).querySelectorAll("[data-sx-carousel]").forEach(function (el) {
      if (el.__sxCarousel) return;
      el.__sxCarousel = new SxCarousel(el);
    });
  }

  function initChaseBars(scope) {
    (scope || document).querySelectorAll(".sx-chase").forEach(function (bar) {
      if (bar.__sxBound) return;
      bar.__sxBound = true;
      var after = parseFloat(bar.getAttribute("data-show-after") || "0.5");
      var tick = function () {
        var threshold = after <= 1 ? window.innerHeight * after : after;
        bar.classList.toggle("is-visible", window.scrollY > threshold);
      };
      window.addEventListener("scroll", tick, { passive: true });
      window.addEventListener("resize", tick);
      tick();
    });
  }

  function initImmersive() {
    var hero = document.querySelector("[data-sx-immersive='true']");
    document.body.classList.toggle("sx-immersive", !!hero);
  }

  function initAll(scope) {
    initReveals(scope);
    initCarousels(scope);
    initChaseBars(scope);
    initImmersive();
  }

  window.__SX_REINIT__ = function () { initAll(document); };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target);
  });
  document.addEventListener("shopify:section:select", function (e) {
    initImmersive();
  });
})();
